var map = {
	"./activity1.png": "65f8",
	"./activity2.png": "40e8",
	"./activity2_1.png": "a725",
	"./activity2_2.png": "dd29",
	"./collection1.png": "f6bc",
	"./collection2.png": "2ac2",
	"./collection3.png": "86d7",
	"./collection4.png": "56a5",
	"./experienceGold.png": "0c51",
	"./home1.png": "d201",
	"./home2.png": "227b",
	"./hot.png": "d2a2",
	"./livre.png": "e36d",
	"./menu1.png": "f247",
	"./menu2.png": "d7bc",
	"./new.png": "dfdc",
	"./promotion1.png": "9dc9",
	"./promotion2.png": "44c8",
	"./promotion2_1.png": "8e00",
	"./promotion2_2.png": "5c4f",
	"./recommend.png": "0fd8",
	"./share_img1.png": "56e9",
	"./share_img2.png": "53fd",
	"./share_img3.png": "c7be",
	"./share_img4.png": "364e",
	"./share_img5.png": "5921",
	"./share_img6.png": "dac9",
	"./share_img7.png": "73ed",
	"./share_img8.png": "8bd5",
	"./user1.png": "eede",
	"./user2.png": "860f",
	"./user2_1.png": "17c3",
	"./user2_2.png": "3106",
	"./xiaolaba.png": "1a6e",
	"./zanwu.png": "c3a7",
	"./充值_1.png": "4ab8",
	"./充值_2.png": "1bb0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da20";